module.exports = __webpack_public_path__ + "assets/altcoinminingpoolssite.dc7bbffb.png";